import React, { useState } from "react";
import moment from 'moment-timezone';
import { useApolloClient } from "@apollo/react-hooks";
import { Dropdown } from "components/common";
import formatCurrency from 'utils/formatCurrency';
import { SUBMIT_BOOST_SELF_ADD_TRANSACTION, GET_CREDIT_BOOST_TRANSACTIONS, GET_NON_MATCHED_TRANSACTIONS_GQL } from "../../mutations";

const CATEGORIES = [
  "Mobile Phone",
  "Utilities",
  "Internet",
  "Television / Video Streaming",
  "Gym",
  "Electricity",
  "Gas",
  "Rent",
  "Other",
];

const BoostSelectedBill = ({
  selectedBill,
  handleSelectedBill,
  transactions,
}) => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [category, setSelectedCategory] = useState("category");

  const buttonDisabled = ((category === "category" && !successMessage) || loading);
  const buttonHoverStyle = buttonDisabled && !loading ? {} : { backgroundColor: "#4B2BA3" };

  const handleSubmitSelfAdd = async () => {
    // if we already have a successMessage
    // button takes you back to the list.
    if (successMessage) {
      handleSelectedBill(selectedBill);
      return;
    }

    setLoading(true);
    setErrorMessage("");
    try {
      await client.mutate({
        mutation: SUBMIT_BOOST_SELF_ADD_TRANSACTION,
        variables: {
          transaction: {
            id: selectedBill.id,
            source: selectedBill.source,
            category,
          },
        },
        // tell boostEnrolled to refetch data..
        refetchQueries: [
          { query: GET_CREDIT_BOOST_TRANSACTIONS },
        ],
        // keep this cache updated since were not regrabbing from network everytime this click this.
        // if they refresh this doesnt matter since it will trigger a network call.
        update: (async (cache, _) => {
          const data = await cache.readQuery({ query: GET_NON_MATCHED_TRANSACTIONS_GQL }) || {};
          const { transactions: cachedTransactions = [] } = data?.getNonMatchedTransactions || {};
          const thisIdx = cachedTransactions.findIndex((trans) => trans.id === selectedBill.id);
          if (thisIdx !== -1) {
            cachedTransactions.splice(thisIdx, 1);
            cache.writeQuery({ query: GET_NON_MATCHED_TRANSACTIONS_GQL, data });
          }
        }),
      });
      setLoading(false);
      // success status.
      // remove this bill from the list..
      const idx = transactions.findIndex((trans) => { return trans.id === selectedBill.id; });
      transactions.splice(idx, 1);
      const success = `Successfully added as a bill`;
      setSuccessMessage(success);
      // setButtonHoverStyle({});
    } catch (error) {
      // setButtonHoverStyle({});
      setErrorMessage(error?.graphQLErrors[0]?.message);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex flex-row mx-auto bg-gray-200 border-gray-500 border-b pl-4 ">
        <button
          type="button"
          className="mt-2 mr-2"
          onClick={() => {
            handleSelectedBill(selectedBill);
          }}
        >
          <i className="text-2xl fa-solid fa-arrow-left" />
        </button>
        <h3 className="mt-2 text-xl">{"Add your bill"}</h3>
      </div>
      <div
        style={{ minHeight: "100%" }}
        className="flex py-2 px-4 flex-col bg-white"
      >
        <div className="rounded-lg flex flex-col justify-evenly">
          <div className="flex flex-col my-2 w-full px-2">
            <div className="flex flex-row">
              <div className="whitespace-nowrap w-full flex flex-row justify-between">
                <div>
                  {moment.unix(selectedBill.posteddate).format("MMM DD")}
                </div>
                <div>{formatCurrency(selectedBill.amount)}</div>
              </div>
            </div>
            <div className="flex flex-row mt-2 w-4/5 justify-between">
              <div style={{ wordBreak: "break-word" }}>
                {selectedBill.description}
              </div>
            </div>
          </div>
          <p className="px-2">
            {" "}
            <i>Select a category</i>
          </p>
          <div style={{ height: "25vh" }} className="overflow-y-auto">
            <Dropdown
              id="dropdown"
              disabled={!!successMessage}
              elements={CATEGORIES}
              selectedElement={category}
              didSelect={(e) => {
                setSelectedCategory(e);
              }}
              className="max-w-lg"
              componentProps={{ className: "py-2" }}
            />
          </div>
          <p className="px-2 text-sm">
            * Self added bills may be subject to review. Make sure any bills you
            are adding are recurring.
          </p>
          <div className="flex flex-col items-center py-4">
            <div className="flex justify-center mb-2">
              {errorMessage && (
                <p className="text-red-600 text-sm">{errorMessage}</p>
              )}
              {successMessage && (
                <p className="text-green-primary text-sm">{successMessage}</p>
              )}
            </div>
            <button
              className="btn w-1/2 text-base bg-boost-primary-purple pb-2 border-none"
              type="button"
              style={buttonHoverStyle}
              disabled={buttonDisabled}
              onClick={handleSubmitSelfAdd}
            >
              {loading ? (
                <i className="fa-solid fa-circle-notch fa-spin text-white" />
              ) : (
                <></>
              )}
              {!loading ? (
                successMessage ? (
                  "Add Another Bill"
                ) : (
                  "Add bill"
                )
              ) : (
                <></>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BoostSelectedBill;